<template>
  <section class="card">
    <div class="card-title">
      <div class="question">
        <p class="subtitle-1">Question</p>
      </div>
      <p v-if="showAnswer" class="subtitle-1">Answer</p>
    </div>
    <div class="content">
      <slot />
    </div>
  </section>
</template>
  
  <script>
/**
 * @fileoverview Updated Values Summary Card component
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "SummaryCard",
  props: {
    showAnswer: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.card-title {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 12px 16px;
  background: $qvo-color-blue-100;
  border-radius: 8px 8px 0 0;
  align-items: center;
  gap: 10px;
  border: 1px solid $qvo-color-grey-200;
  border-bottom: none;
  .question {
    display: flex;
    align-items: center;
    gap: $qvo-spacing-8;
  }
}
.content {
  border: 1px solid $qvo-color-grey-200;
  border-radius: 0 0 8px 8px;
}
</style>